import formsRedux from '../../views/list/redux/slice'
import formsEditRedux from '../../views/edit/redux/slice'
import formsCatalogsEditRedux from '../../modals/editCatalog/redux/slice'
//export redux objects
export default {
	formsRedux,
	formsEditRedux,
	formsCatalogsEditRedux
};